/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import { storageNewApiHost } from '@/model/dataLayer/api/storage/inventoryUtils'
import { groupBy, sumBy } from 'lodash'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'

const entity = {
  productName: {
    displayName: 'name'
  },
  totalCostLiteral: {
    displayName: 'price',
    type: IKDataEntity.Types.Float
  },
  totalAmount: {
    displayName: 'amount'
  }
}

const config = {
  load: async function (filter) {
    const [startTime, endTime] = filter[0].dateFilter
    const res = (await hillo.jsonPost(storageNewApiHost + 'change/list/' + await getCurrentDeviceId(), {
      dateTimeFrom: startTime + 'T00:00:00.000Z',
      dateTimeTo: endTime + 'T23:59:59.000Z'
    })).filter(x => x.operationType === 'Out')
    return Object.entries(groupBy(res, 'storageItem.name')).map(it => {
      return {
        productName: it[0],
        totalAmount: sumBy(it[1], (a) => {
          return a.amount
        }) + it[1][0]?.storageItem?.units[0].name,
        totalCostLiteral: sumBy(it[1], (b) => {
          return b.costLiteral
        })
      }
    })
  }
}

export default IKDataEntity.ModelFactory(entity, config)
